import React from "react";
import Text from "../../text/Text";
import Box from "../../box/Box";
var DiscontinuedView = function () {
    return (React.createElement(Box, null,
        React.createElement(Text, { fontWeight: "bold", m: 3, color: "gameRed" }, "This product has been discontinued.")));
};
export default DiscontinuedView;
//# sourceMappingURL=DiscontinuedView.js.map